import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

import { withRouter } from 'react-router-dom';
// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';

// Component styles
import styles from './styles';
import BaseDataRegisters from './BaseDataRegisters'
import moment from 'moment'
import 'moment/locale/es'
import { Box, DialogContent, DialogTitle, Switch, TextField } from '@material-ui/core';
import { AtCircularProgress } from '../../../../components/AtCircularProgress';
import { differenceInSeconds, format } from 'date-fns';
import { getQueryParams } from '../../../../utils/fns/get-query-params';
import { withTranslation } from 'react-i18next';
moment.locale('es')


class BaseRegisters extends Component {
    constructor(props) {
        super(props);
        var nodes=(props.location.state.fromObjective.Nodos)
        var listNodes=[]                                                                                            
        nodes.map(node=>{
            if(node["nodo"]!=='Global'){
                listNodes.push(node)
            }
        })
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        var monitores=(props.location.state.fromObjective.Monitores)
        this.myCallback = this.myCallback.bind(this);
        const erroresList = t('base-registers-plus.errors', { returnObjects: true });
        this.state = {
            objetive: this.props.match.params.objetivo_id,
            isStatePeriod: false,
            settingsEl: null,
            steps:this.props.location.state.fromObjective.Pasos,
            isRefresh: false,
            isInfo: null,
            nodes:listNodes,
            listMonitores:monitores,
            errors:[erroresList["0"], erroresList["1"], erroresList["2"], erroresList["3"], erroresList["4"], erroresList["5"]],
            indexError:0,
            buttonBoolean:true,
            isLoad:false,
            dateMoment:moment(),
            dateBefore:moment().subtract({'hours': 1}),
            limit:new Date(new Date().setDate(new Date().getDate() - 6)),
            limit2:new Date(),
            clockBegin: format(new Date(new Date().setHours(new Date().getHours() - 1)), 'yyyy-MM-dd HH:mm'),
            clockFinal: format(new Date(), 'yyyy-MM-dd HH:mm'),
            open:false,
            isLoadButton:false,
            showOnlyWithRegisters: true,
        };
    }
    myCallback = (dataFromChild) => {
        this.setState({
            isLoadButton:false,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevState.buttonBoolean!== this.state.buttonBoolean){
            this.getData()
        }
    }
    getData=()=>{
        this.setState({
            isLoad:false,
            isLoadButton:false,
        })
    }
    openModal=(event)=>{
        this.setState({
            open:true
        })
    }

    onCloseModal = () => {
        this.setState({ open: false });
    };

    handleClose = event => {
        this.props.onClose()
    };
    
    changeLoad=()=>{
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        const {clockBegin, clockFinal, limit, limit2}=this.state
        if (limit > new Date(clockBegin)) {
            alert(t('base-registers-plus.change-load.errors.start-date-before-7-days'))
            return
        }
        if (new Date(clockFinal) <= new Date(clockBegin)) {
            alert(t('base-registers-plus.change-load.errors.end-date-less-or-equal-start-date'))
            return
        }
        if (differenceInSeconds(new Date(clockFinal), new Date(clockBegin)) > 3600) {
            alert(t('base-registers-plus.change-load.errors.range-greater-than-one-hour'))
            return
        }
        if(new Date(clockFinal) > limit2){
            alert(t('base-registers-plus.change-load.errors.end-date-greater-than-current-date'))
            return
        }
        this.setState({
            dateBefore:moment(clockBegin),
            dateMoment:moment(clockFinal),
            isLoadButton:true,
        })
    }
    
    render() {        
        const {nodes, steps, objetive, dateMoment, dateBefore, isLoad} = this.state;
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (isLoad===true) {
            return(
                <AtCircularProgress />
            )
        }else{
            return (
                <>
                    <DialogTitle className='at-blue-background'>
                        <Box display='flex' flexDirection='row' width='100%' alignItems='center' justifyContent='space-between'>
                            <Typography variant="h4" className='white'>{t('base-registers-plus.title')}</Typography>
                            <IconButton key="close" aria-label="close" onClick={this.handleClose}><CloseIcon/></IconButton>
                        </Box>                                        
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} style={{paddingTop: 10}}>
                            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                <TextField
                                    fullWidth
                                    type='datetime-local'
                                    variant='outlined'
                                    size='small'
                                    label={t('text.from')}
                                    InputLabelProps={{shrink: true}}
                                    value={this.state.clockBegin}
                                    onChange={e => this.setState({clockBegin: e.currentTarget.value})}
                                    />
                            </Grid>
                            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                <TextField
                                    fullWidth
                                    type='datetime-local'
                                    variant='outlined'
                                    size='small'
                                    label={t('text.to')}
                                    InputLabelProps={{shrink: true}}
                                    value={this.state.clockFinal}
                                    onChange={e => this.setState({clockFinal: e.currentTarget.value})}
                                />
                            </Grid>
                            <Grid item xl={12} xs={12}>
                                <Box display='flex' justifyContent='space-between'>
                                    {!this.props.esIVR ?
                                        <Button size='small' variant='text' color='primary' onClick={() => {
                                            this.props.history.push({
                                                pathname: '/manageObjectives',
                                                query: { tab: 7, objetivoId: this.state.objetive },
                                                search: getQueryParams(),
                                            })
                                        }}>{t('base-registers-plus.link.go-to-settings')}</Button>
                                    : <Box />}
                                    <Button size='small' onClick={() => this.changeLoad()} variant='outlined' color='primary'>
                                        {t('base-registers-plus.button.filter')}
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid item xl={12} xs={12}>
                                <Box display='flex' alignItems='center' justifyContent='end'>
                                    <Typography variant='h6' style={{color: "#6b6b6b"}}>{t('base-registers-plus.button.text.with-register')}</Typography>
                                    <Box style={{marginLeft: '10px'}}>
                                        <Switch
                                            checked={this.state.showOnlyWithRegisters}
                                            onChange={() => this.setState({showOnlyWithRegisters: !this.state.showOnlyWithRegisters})}
                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            color='primary'
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                        <Box marginTop={2} marginBottom={2}>
                            <BaseDataRegisters callbackFromParent={this.myCallback} nodes={nodes} objective={objetive} steps={steps} dateBegin={dateBefore} dateFinal={dateMoment} showOnlyWithRegisters={this.state.showOnlyWithRegisters} esIVR={this.props.esIVR} />
                        </Box>
                    </DialogContent>
                </>
            )
        
        }

        
    }
}


export default
    compose(withRouter, withStyles(styles), withTranslation())(BaseRegisters);